<template>
<div class="widthFull center pt-1 pb-3">


  <div class="row justify-content-center pb-3">

    <div class="col-md-11  center">

      <h4 v-if="PaypalOn" class="center"><b>Oppure puoi pagare con la tua carta <span v-if="sepaOn">o addebito diretto SEPA</span></b></h4>
      <h4 v-else class="center"><b>Paga con la tua carta <span v-if="sepaOn">o con addebito bancario diretto SEPA</span></b></h4>

      <img v-if="sepaOn" class="img-fluid widthFull mb-3 mt-3" src="../../assets/images/card.png">
      <img v-else class="img-fluid widthFull mb-3 mt-3" src="../../assets/images/cardonly.png">

    </div>
    <div class="col-md-8  center">
      <button v-if="!show_card" type="button" class="btn btn-secondary" id="checkout-button" v-on:click="create_stripe_session"> Procedi </button>
    </div>

  </div>

</div>
</template>

<script>
import {
  AUTH_REQUEST,
  AUTH_SOCIAL
} from 'actions/auth'
import {
  mapGetters,
  mapState
} from 'vuex'
import axios from 'axios'

import Vue from 'vue'

const moment = require('moment')

export default {
  name: 'stripe',
  components: {
    //StripeCheckout
  },
  props: {
    practice: String,
    userToken: String,
    items: Array,
    invoiceNumber: String,
    amount: String,
    PaypalOn: Boolean,
    flow: String,
    sepaOn: Boolean,
    discount: String,
    discountValue: String,
    dl: String,
  },
  data() {
    return {
      token: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      error: '',
      loadingState: false,
      loading: false,
      moment: require('moment'),
      show_card: false,
      //STRIPE
      pk: process.env.STRIPE_PUBLISHABLE_KEY,
      front_url: process.env.FRONT_END_URL,
      iva: process.env.IVA,
      buyPlan: {
        price: process.env.PRACTIC_PRICE,
        iva: process.env.PRACTIC_PRICE * 0.22,
        amount: (process.env.PRACTIC_PRICE + process.env.PRACTIC_PRICE * 0.22),
        amount_enea: parseFloat(process.env.PRACTIC_PRICE + (process.env.PRACTIC_PRICE * 0.22) + 50 * 1.22).toFixed(2),
        amount_dcast: parseFloat(process.env.PRACTIC_PRICE + (process.env.PRACTIC_PRICE * 0.22) + 10 * 1.22).toFixed(2),
        amount_enea_dcast: parseFloat(process.env.PRACTIC_PRICE + (process.env.PRACTIC_PRICE * 0.22) + 50 * 1.22 + 10 * 1.22).toFixed(2),
        priceEnea: 50,
        ivaEnea: 11,
        priceDcast: 10,
        ivaDcast: 2.2
      },

    }

  },
  methods: {
    // composer require stripe/stripe-php
    create_stripe_session() {
      this.loadingState = true
      // Create an instance of the Stripe object with your publishable API key
      var stripe = Stripe(this.pk);

      if (this.discountValue != 0 && this.discountValue != '0') {
        var data = {
          userToken: this.userToken,
          practice: this.practice,
          items: this.items,
          amount: this.amount,
          invoiceNumber: this.invoiceNumber,
          pk: this.pk,
          errorUrl: process.env.FRONT_END_URL + 'paymentError/' + this.practice + '?discount=' + this.discount + '&discountValue=' + this.discountValue ,
          successUrl: process.env.FRONT_END_URL + 'paymentSuccess/' + this.practice + '?discount=' + this.discount + '&discountValue=' + this.discountValue
        }
      } else {

        var data = {
          userToken: this.userToken,
          practice: this.practice,
          items: this.items,
          amount: this.amount,
          invoiceNumber: this.invoiceNumber,
          pk: this.pk,
          errorUrl: process.env.FRONT_END_URL + 'paymentError/' + this.practice,
          successUrl: process.env.FRONT_END_URL + 'paymentSuccess/' + this.practice
        }

      }

      axios({
          url: process.env.ROOT_API + 'api/create-stripe-checkout-session',
          method: 'POST',
          data: data,
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {
          this.loadingState = false
          console.log(resp.data)
          return stripe.redirectToCheckout({
            sessionId: resp.data.status.id
          });

        })
        .catch(resp => {

          this.loadingState = false
          this.showAlert()

        })

    },
    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Ci dispiace! Riprova piu tardi',
      });
    },

  },
  watch: {

  },
  created() {

    this.$loadScript("https://js.stripe.com/v3/")
      .then(() => {
        this.loadButtons = false
      })
      .catch(() => {
        // Failed to fetch script
      });

  },

  mounted() {

    if( this.dl == 'old' ){
      // OLD FLOW
      var practicPrice = (this.$route.params.item.flow == 'poste' ? 160 : 230)
      var visto = 0
    }else{
      // NEW FLOW
      var practicPrice = (this.$route.params.item.flow == 'poste' ? process.env.PRACTIC_PRICE : process.env.PRACTIC_PRICE_CDP)
      var visto = process.env.PRACTIC_VISTO
    }

    var price = parseFloat( practicPrice + ( visto )  - this.discountValue)


    this.buyPlan = {
        price: practicPrice,
        iva: practicPrice * 0.22 + ( visto * 0.22 ),
        amount: (practicPrice + ( process.env.PRACTIC_VISTO * 1.22 ) + practicPrice * 0.22),
        amount_enea: parseFloat(practicPrice + ( process.env.PRACTIC_VISTO * 1.22 ) + (practicPrice * 0.22) +
          50 * 1.22).toFixed(2),
        amount_dcast: parseFloat(practicPrice + ( process.env.PRACTIC_VISTO * 1.22 ) + (practicPrice * 0.22) +
          10 * 1.22).toFixed(2),
        amount_enea_dcast: parseFloat(practicPrice + ( process.env.PRACTIC_VISTO * 1.22 ) + (practicPrice *
          0.22) + 50 * 1.22 + 10 * 1.22).toFixed(2),
        priceEnea: 50,
        visto: visto,
        ivaEnea: 11,
        priceDcast: 10,
        ivaDcast: 2.2,
    }


  },
  computed: {
    ...mapGetters(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    }),

  },
}
</script>

<style lang="css" scoped>
form {
  width: 30vw;
  min-width: 500px;
  align-self: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 7px;
  padding: 40px;
}
input {
  border-radius: 6px;
  margin-bottom: 6px;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  font-size: 16px;
  width: 100%;
  background: white;
}
.result-message {
  line-height: 22px;
  font-size: 16px;
}
.result-message a {
  color: rgb(89, 111, 214);
  font-weight: 600;
  text-decoration: none;
}
.hidden {
  display: none;
}
#card-error {
  color: rgb(105, 115, 134);
  text-align: left;
  font-size: 13px;
  line-height: 17px;
  margin-top: 12px;
}
#card-element {
  border-radius: 4px 4px 0 0 ;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  width: 100%;
  background: white;
}
#payment-request-button {
  margin-bottom: 32px;
}
/* Buttons and links */
button {
  background: #5469d4;
  color: #ffffff;
  font-family: Arial, sans-serif;
  border-radius: 0 0 4px 4px;
  border: 0;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
}
button:hover {
  filter: contrast(115%);
}
button:disabled {
  opacity: 0.5;
  cursor: default;
}
/* spinner/processing state, errors */
.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}
.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}
.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: #5469d4;
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  -webkit-transform-origin: 10.4px 10.2px;
  transform-origin: 10.4px 10.2px;
  -webkit-animation: loading 2s infinite ease 1.5s;
  animation: loading 2s infinite ease 1.5s;
}
.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: #5469d4;
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  -webkit-transform-origin: 0px 10.2px;
  transform-origin: 0px 10.2px;
  -webkit-animation: loading 2s infinite ease;
  animation: loading 2s infinite ease;
}
@-webkit-keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@media only screen and (max-width: 600px) {
  form {
    width: 80vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loadDocuments/stripe.vue